export default __webpack_public_path__ + "static/hacktoberfest2021-b4afecae9f61180d8c1d4431c2a4469d.webp";